export const baseConfig = [
  // {
  //   icon: 'saas-obs/202406/66601de5e4b0779fb39f5809.svg',
  //   nid: '001',
  //   key: 'Config', //配置成子应用对应的name
  //   name: '基础业务配置',
  //   path: '/main/config',
  //   sortNumber: 22,
  //   sysVisibleFlag: 1,
  //   type: 'menu',
  //   children: [
  //     // 产品管理
  //     {
  //       key: 'baseProductManage',
  //       appPath: '/main/config',
  //       nid: '002',
  //       name: '产品管理',
  //       sortNumber: 2,
  //       sysVisibleFlag: 1,
  //       type: 'menu',
  //       children: [
  //         {
  //           key: 'packageTemplate',
  //           nid: '003',
  //           name: '打包模板',
  //           path: '/baseProduct/packageTemplate',
  //           appPath: '/main/config',
  //           completePath: '/main/config/baseProduct/packageTemplate',
  //           sortNumber: 1,
  //           sysVisibleFlag: 1,
  //           type: 'menu',
  //           children: [
  //             {
  //               key: 'packageTemplate_AddOrEdit',
  //               nid: '004',
  //               name: '新增/编辑打包模板',
  //               path: '/baseProduct/packageTemplate/addOrEdit/:id',
  //               appPath: '/main/config',
  //               completePath: '/main/config/baseProduct/packageTemplate/addOrEdit/:id',
  //               sortNumber: 1,
  //               sysVisibleFlag: 0,
  //               type: 'menu',
  //             },
  //             {
  //               key: 'packageTemplate_AddOrEdit_subItem',
  //               nid: '004',
  //               name: '子项详情',
  //               path: '/baseProduct/packageTemplate/addOrEdit/childItemDetail/:id',
  //               appPath: '/main/config',
  //               completePath:
  //                 '/main/config/baseProduct/packageTemplate/addOrEdit/childItemDetail/:id',
  //               sortNumber: 1,
  //               sysVisibleFlag: 0,
  //               type: 'menu',
  //             },
  //           ],
  //         },
  //         {
  //           key: 'subItem',
  //           nid: '004',
  //           name: '子项管理',
  //           path: '/baseProduct/subItemList',
  //           appPath: '/main/config',
  //           completePath: '/main/config/baseProduct/subItemList',
  //           sortNumber: 1,
  //           sysVisibleFlag: 1,
  //           type: 'menu',
  //           children: [
  //             {
  //               name: '新增/编辑子项',
  //               key: 'packageTemplate_subItem_AddOrEdit',
  //               path: '/baseProduct/subItemList/addOrEdit/:id',
  //               appPath: '/main/config',
  //               completePath: '/main/config/baseProduct/subItemList/addOrEdit/:id',
  //               sortNumber: 1,
  //               sysVisibleFlag: 0,
  //               type: 'menu',
  //             },
  //           ],
  //         },
  //         {
  //           key: 'priceStrategy',
  //           nid: '005',
  //           name: '价格策略',
  //           path: '/baseProduct/priceStrategy',
  //           appPath: '/main/config',
  //           completePath: '/main/config/baseProduct/priceStrategy',
  //           sortNumber: 1,
  //           sysVisibleFlag: 1,
  //           type: 'menu',
  //         },
  //         {
  //           key: 'generalManage',
  //           nid: '006',
  //           name: '通项管理',
  //           path: '/baseProduct/generalManage',
  //           appPath: '/main/config',
  //           completePath: '/main/config/baseProduct/generalManage',
  //           sortNumber: 1,
  //           sysVisibleFlag: 1,
  //           type: 'menu',
  //         },
  //         {
  //           key: 'parameterManage',
  //           nid: '007',
  //           name: '参数管理',
  //           path: '/baseProduct/parameterManage',
  //           appPath: '/main/config',
  //           completePath: '/main/config/baseProduct/parameterManage',
  //           sortNumber: 1,
  //           sysVisibleFlag: 1,
  //           type: 'menu',
  //         },
  //         {
  //           key: 'productManage',
  //           nid: '008',
  //           name: '产品管理',
  //           path: '/productManage',
  //           appPath: '/main/config',
  //           completePath: '/main/config/productManage',
  //           sortNumber: 2,
  //           sysVisibleFlag: 2,
  //           type: 'menu',
  //           children: [
  //             {
  //               key: 'productSteps',
  //               nid: '009',
  //               name: '新增产品',
  //               path: '/productManage/productSteps',
  //               appPath: '/main/config',
  //               completePath: '/main/config/productManage/productSteps',
  //               sortNumber: 2,
  //               sysVisibleFlag: false,
  //               type: 'menu',
  //             },
  //           ],
  //         },
  //         {
  //           key: 'productClass',
  //           nid: '010',
  //           name: '产品分类',
  //           path: '/productClass',
  //           appPath: '/main/config',
  //           completePath: '/main/config/productClass',
  //           sortNumber: 3,
  //           sysVisibleFlag: 3,
  //           type: 'menu',
  //           children: [],
  //         },
  //         {
  //           key: 'projectManage',
  //           nid: '011',
  //           name: '项目管理',
  //           path: '/projectManage',
  //           appPath: '/main/config',
  //           completePath: '/main/config/projectManage',
  //           sortNumber: 4,
  //           sysVisibleFlag: 4,
  //           type: 'menu',
  //           children: [],
  //         },
  //         {
  //           key: 'priceTagManage',
  //           nid: '012',
  //           name: '费用项',
  //           path: '/priceTagManage',
  //           appPath: '/main/config',
  //           completePath: '/main/config/priceTagManage',
  //           sortNumber: 4,
  //           sysVisibleFlag: 4,
  //           type: 'menu',
  //           children: [
  //             {
  //               key: 'specialConfig',
  //               nid: 'specialConfig',
  //               name: '特殊配置',
  //               path: '/priceTagManage/specialConfig/:id',
  //               appPath: '/main/config',
  //               completePath: '/main/config/priceTagManage/specialConfig/:id',
  //               sortNumber: 4,
  //               sysVisibleFlag: 4,
  //               type: 'menu',
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     // 商品配置
  //     // {
  //     //   key: 'commodityConfig',
  //     //   appPath: '/main/config',
  //     //   nid: '013',
  //     //   name: '商品配置',
  //     //   sortNumber: 2,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [
  //     //     {
  //     //       key: 'commodityManage',
  //     //       nid: '014',
  //     //       name: '商品管理',
  //     //       path: '/commodityManage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/commodityManage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //       children: [
  //     //         {
  //     //           key: 'commodityEdit',
  //     //           nid: '015',
  //     //           name: '新增商品',
  //     //           path: '/commodityManage/commodityEdit', // 必须写成/commodityManage/xx 才能继续显示菜单
  //     //           appPath: '/main/config',
  //     //           completePath: '/main/config/commodityManage/commodityEdit',
  //     //           sortNumber: 1,
  //     //           sysVisibleFlag: false,
  //     //           type: 'menu',
  //     //         },
  //     //         {
  //     //           key: 'commodityArrive',
  //     //           nid: '016',
  //     //           name: '商品上下架',
  //     //           path: '/commodityManage/commodityArrive', // 必须写成/commodityManage/xx 才能继续显示菜单
  //     //           appPath: '/main/config',
  //     //           completePath: '/main/config/commodityManage/commodityArrive',
  //     //           sortNumber: 1,
  //     //           sysVisibleFlag: false,
  //     //           type: 'menu',
  //     //         },
  //     //       ],
  //     //     },
  //     //     {
  //     //       key: 'categoryManage',
  //     //       nid: '017',
  //     //       name: '品类管理',
  //     //       path: '/categoryManage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/categoryManage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }, {
  //     //       key: 'sellManage',
  //     //       nid: '018',
  //     //       name: '销售类目管理',
  //     //       path: '/sellManage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/sellManage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }
  //     //   ]
  //     // }, {
  //     //   key: 'contentConfig',
  //     //   appPath: '/main/config',
  //     //   nid: '006',
  //     //   name: '内容',
  //     //   sortNumber: 2,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [
  //     //     {
  //     //       key: 'article-manage',
  //     //       nid: '007',
  //     //       name: '文章',
  //     //       path: '/article-manage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/article-manage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }, {
  //     //       key: 'vr-manage',
  //     //       nid: '008',
  //     //       name: 'VR案例',
  //     //       path: '/vr-manage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/vr-manage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }, {
  //     //       key: 'video-manage',
  //     //       nid: '009',
  //     //       name: '视频',
  //     //       path: '/video-manage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/video-manage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }, {
  //     //       key: 'tag-manage',
  //     //       nid: '0010',
  //     //       name: '内容标签',
  //     //       path: '/tag-manage',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/tag-manage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     }
  //     //   ]
  //     // },
  //     // // 合同管理
  //     // {
  //     //   key: 'contractManage',
  //     //   appPath: '/main/config',
  //     //   nid: '019',
  //     //   name: '合同管理',
  //     //   sortNumber: 2,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [
  //     //     {
  //     //       key: 'quoteContract',
  //     //       nid: '020',
  //     //       name: '报价合同配置',
  //     //       path: '/quoteContract',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/quoteContract', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     },
  //     //     {
  //     //       key: 'contractTemplate',
  //     //       nid: '032',
  //     //       name: '合同模板管理',
  //     //       path: '/contractTemplate',
  //     //       appPath: '/main/config',
  //     //       completePath: '/main/config/contractTemplate', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //       sortNumber: 1,
  //     //       sysVisibleFlag: 1,
  //     //       type: 'menu',
  //     //     },
  //     //   ],
  //     // },
  //     // {
  //     //   key: 'memberConfig',
  //     //   appPath: '/main/config',
  //     //   nid: '006',
  //     //   name: '会员',
  //     //   sortNumber: 2,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'userMember',
  //     //     nid: '0010',
  //     //     name: '会员列表',
  //     //     path: '/member/user',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/user', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   },
  //     //   {
  //     //     key: 'levelMember',
  //     //     nid: '007',
  //     //     name: '会员等级',
  //     //     path: '/member/level',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/level', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'eventMember',
  //     //     nid: '008',
  //     //     name: '会员事件库',
  //     //     path: '/member/event',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/event', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'equityTypeMember',
  //     //     nid: '009',
  //     //     name: '权益分类',
  //     //     path: '/member/equity-type',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/equity-type', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'equityMember',
  //     //     nid: '0010',
  //     //     name: '会员权益库',
  //     //     path: '/member/equity',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/equity', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'taskMember',
  //     //     nid: '0010',
  //     //     name: '任务配置',
  //     //     path: '/member/task',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/member/task', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   },
  //     //     // {
  //     //     //   key: 'tagManage',
  //     //     //   nid: '0010',
  //     //     //   name: '会员商城',
  //     //     //   path: '/tagManage',
  //     //     //   appPath: '/main/config',
  //     //     //   completePath: '/main/config/tagManage', // 用来点击业务配置时定位，本身也可以直接拼接
  //     //     //   sortNumber: 1,
  //     //     //   sysVisibleFlag: 1,
  //     //     //   type: 'menu',
  //     //     // }
  //     //   ]
  //     // },
  //     // {
  //     //   key: 'clueConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-003',
  //     //   name: '线索配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'launchPlatform',
  //     //     nid: 'yyn-004',
  //     //     name: '投放平台对接',
  //     //     path: '/clueConfig/launchPlatform',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/clueConfig/launchPlatform',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'clueAccountSet',
  //     //     nid: 'yyn-005',
  //     //     name: '线索账号对接',
  //     //     path: '/clueConfig/clueAccountSet',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/clueConfig/clueAccountSet',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // },
  //     // {
  //     //   key: 'customerConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-005',
  //     //   name: '客户配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'customerLabel',
  //     //     nid: 'yyn-006',
  //     //     name: '客户标签',
  //     //     path: '/customerConfig/customerLabel',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/customerConfig/customerLabel',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'salesBusiness',
  //     //     nid: 'yyn-00999',
  //     //     name: '销售业务',
  //     //     path: '/customerConfig/salesBusiness',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/customerConfig/salesBusiness',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 2,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'assignTasks',
  //     //     nid: 'yyn-007',
  //     //     name: '分配人管理',
  //     //     path: '/customerConfig/assignTasks',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/customerConfig/assignTasks',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // },
  //     // {
  //     //   key: 'targetConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-012',
  //     //   name: '目标配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'objectiveManage',
  //     //     nid: 'yyn-013',
  //     //     name: '目标管理',
  //     //     path: '/targetConfig/objectiveManage',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/targetConfig/objectiveManage',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'achievementDate',
  //     //     nid: 'yyn-014',
  //     //     name: '业绩期管理',
  //     //     path: '/targetConfig/achievementDate',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/targetConfig/achievementDate',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // },
  //     // {
  //     //   key: 'serviceConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-007',
  //     //   name: '服务配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'nodeConfig',
  //     //     nid: 'yyn-009',
  //     //     name: '节点配置',
  //     //     path: '/serviceConfig/nodeConfig',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/nodeConfig',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'serviceManage',
  //     //     nid: 'yyn-010',
  //     //     name: '服务管理',
  //     //     path: '/serviceConfig/serviceManage',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/serviceManage',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'workerManagement',
  //     //     nid: 'yyn-011',
  //     //     name: '承包商配置',
  //     //     path: '/serviceConfig/workerManagement',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/workerManagement',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'externalPerson',
  //     //     nid: 'yyn-011',
  //     //     name: '工人管理',
  //     //     path: '/serviceConfig/externalPerson',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/externalPerson',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'insuranceConfig',
  //     //     nid: 'yyn-011',
  //     //     name: '保险管理',
  //     //     path: '/serviceConfig/insuranceConfig',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/insuranceConfig',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'retentionMoney',
  //     //     nid: 'yyn-011',
  //     //     name: '质保金管理',
  //     //     path: '/serviceConfig/retentionMoney',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/serviceConfig/retentionMoney',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // },
  //     // {
  //     //   key: 'channelConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-015',
  //     //   name: '渠道配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'channelLibrary',
  //     //     nid: 'yyn-016',
  //     //     name: '渠道库',
  //     //     path: '/channelConfig/channelLibrary',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/channelConfig/channelLibrary',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'channelClass',
  //     //     nid: 'yyn-017',
  //     //     name: '渠道分类管理',
  //     //     path: '/channelConfig/channelClass',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/channelConfig/channelClass',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // }, {
  //     //   key: 'buildingConfig',
  //     //   appPath: '/main/config',
  //     //   nid: 'yyn-008',
  //     //   name: '楼盘配置',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [{
  //     //     key: 'buildingList',
  //     //     nid: 'yyn-009',
  //     //     name: '楼盘管理',
  //     //     path: '/buildingConfig/buildingList',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/buildingConfig/buildingList',
  //     //     sortNumber: 1,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'buildingArea',
  //     //     nid: 'yyn-010',
  //     //     name: '区域管理',
  //     //     path: '/buildingConfig/buildingArea',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/buildingConfig/buildingArea',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }, {
  //     //     key: 'developerlist',
  //     //     nid: 'yyn-011',
  //     //     name: '开发商管理',
  //     //     path: '/buildingConfig/developerlist',
  //     //     appPath: '/main/config',
  //     //     completePath: '/main/config/buildingConfig/developerlist',
  //     //     sortNumber: 2,
  //     //     sysVisibleFlag: 1,
  //     //     type: 'menu',
  //     //   }]
  //     // },
  //     // {
  //     //   key: 'businessConfiguration',
  //     //   appPath: '/main/config',
  //     //   nid: 'businessConfiguration_1',
  //     //   name: '业务字典',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [
  //     //     {
  //     //       key: 'businessConfigurationList',
  //     //       appPath: '/main/config',
  //     //       path: '/businessConfiguration',
  //     //       name: '业务字典',
  //     //       completePath: '/main/config/businessConfiguration',
  //     //       type: 'menu',
  //     //     }
  //     //   ]
  //     // },
  //     // {
  //     //   key: 'brandManage',
  //     //   appPath: '/main/config',
  //     //   nid: 'brandManage_1',
  //     //   name: '品牌管理',
  //     //   sortNumber: 3,
  //     //   sysVisibleFlag: 1,
  //     //   type: 'menu',
  //     //   children: [
  //     //     {
  //     //       key: 'brandManageList',
  //     //       appPath: '/main/config',
  //     //       path: '/brandManage',
  //     //       name: '品牌管理',
  //     //       completePath: '/main/config/brandManage',
  //     //       type: 'menu',
  //     //     }
  //     //   ]
  //     // },
  //   ],
  // },
]
